export default "__VITE_ASSET__0997c376__"